<template>
  <v-container>
    <v-layout>
      <v-flex lg12>
        <jti-expansion-panel panelName="Store Details">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-lg>
              <v-layout wrap>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.vehicle_no"
                    label="Store Name"
                    :readonly="readonly"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.plate_no"
                    label="Plate Number"
                    :readonly="readonly"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.code"
                    label="Code"
                    :readonly="readonly"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.name"
                    label="Name"
                    :readonly="readonly"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex lg4>
                  <v-select
                    v-model="data.bus_type"
                    label="Bus Type"
                    :readonly="readonly"
                    required
                    :items="bus_types"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>-->
                <!-- <v-flex lg4>
                  <v-text-field v-model="data.model" label="Model" :readonly="readonly"></v-text-field>
                </v-flex>-->
                <v-flex lg4>
                  <v-text-field v-model="data.chasis_no" label="Chasis Number" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field v-model="data.engine_no" label="Engine Number" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.ltfrb_case_no"
                    label="LTFRB Case Number"
                    :readonly="readonly"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    persistent
                    lazy
                    :disabled="readonly"
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="data.registration_date"
                      label="Registration Date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker ref="picker" v-model="data.registration_date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.dialog.save(data.registration_date)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg4>
                  <v-dialog
                    ref="dialog1"
                    v-model="modal1"
                    persistent
                    lazy
                    :disabled="readonly"
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="data.expiration_date"
                      label="Expiration Date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="data.expiration_date"
                      :min="new Date().toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal1 = false">Cancel</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.dialog1.save(data.expiration_date)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg4>
                  <v-select
                    v-model="data.vehicle_layout_id"
                    label="Vehicle Layout"
                    :readonly="readonly"
                    required
                    :items="vehicleLayouts"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex lg4 v-if="showRegisteredSubCompany">
                  <v-select
                    v-model="data.registered_sub_company_id"
                    label="Subcompany Registered to"
                    :readonly="readonly"
                    required
                    :items="subcompanies"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean,
    subcompanies: Array,
    vehicleLayouts: Array,
    showRegisteredSubCompany: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        code: this.data.code,
        vehicle_no: this.data.vehicle_no,
        plate_no: this.data.plate_no,
        // bus_type: this.data.bus_type,
        model: this.data.model,
        chasis_no: this.data.chasis_no,
        engine_no: this.data.engine_no,
        ltfrb_case_no: this.data.ltfrb_case_no,
        registration_date: this.data.registration_date,
        expiration_date: this.data.expiration_date,
        vehicle_layout_id: this.data.vehicle_layout_id,
        registered_sub_company_id: this.data.registered_sub_company_id
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      modal: false,
      modal1: false
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style>
</style>
